import { cva, type VariantProps } from "class-variance-authority";
import type { ComponentProps } from "react";
import { cn } from "~/lib/utils";

const illustrationIconVariants = cva("flex justify-center items-center", {
	variants: {
		variant: {
			default:
				"**:data-ring:bg-background **:data-ground:bg-muted **:data-icon-stroke:stroke-muted-foreground  **:data-icon-fill:fill-muted-foreground/10",
			success:
				"**:data-ring:bg-background **:data-ground:bg-emerald-100 **:data-icon-stroke:stroke-emerald-600  **:data-icon-fill:fill-emerald-200",
		},
	},
	defaultVariants: {
		variant: "default",
	},
});

export function IllustrationIcon({
	children,
	className,
	variant = "default",
	...props
}: ComponentProps<"div"> & VariantProps<typeof illustrationIconVariants>) {
	return (
		<div
			className={cn(illustrationIconVariants({ variant, className }))}
			{...props}
		>
			<div
				data-ring
				className="rounded-full p-1 border border-border/30 shadow-md"
			>
				<div
					data-ground
					className="rounded-full p-4 border border-border/30 inset-shadow-xs"
				>
					{children}
				</div>
			</div>
		</div>
	);
}
